webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return userStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return auth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(9);




var userStorage = {
  get: function get() {
    return JSON.parse(localStorage['user'] || '{}');
  },
  set: function set(credentials) {
    localStorage['user'] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(credentials);
  },
  clear: function clear() {
    delete localStorage['user'];
  }
};

var auth = {
  current: false,

  login: function login(username, password) {
    var _this = this;

    if (typeof username === 'undefined') return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject();
    var credentials = { username: username, password: password };
    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.headers.common['Authorization'] = 'Basic ' + base64(username, password);
    return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post('/api/login').then(function (res) {
      var user = res.body.user;

      userStorage.set(credentials);
      _this.current = user;
      if (!user.permissions || !user.permissions.length) {
        _this.current.permissions = [];
      }
    });
  },
  logout: function logout() {
    this.current = false;
    userStorage.clear();
  },
  isAuthorized: function isAuthorized(action, restriction) {
    if (this.current === false) return false;
    var _current = this.current,
        admin = _current.admin,
        permissions = _current.permissions;

    if (admin === true) return true;
    restriction = Number(restriction);
    var found = permissions.find(function (permission) {
      if (!permission[action]) return;
      if (typeof permission[action] === 'boolean') {
        return permission[action];
      }
      if (permission[action].length) {
        return permission[action].includes(restriction);
      }
    });
    return !!found;
  }
};

function base64(username, password) {
  var auth = username + ':' + password;
  return window.btoa(auth);
}

/* harmony default export */ __webpack_exports__["a"] = (auth);

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

var flash = {
  set: function set(_ref) {
    var type = _ref.type,
        message = _ref.message,
        code = _ref.code,
        _ref$data = _ref.data,
        data = _ref$data === undefined ? {} : _ref$data;

    if (code) message = this.compile(data)[code];
    this.alert = { type: type, message: message };
  },
  now: function now(options) {
    this.set(options);
    return this.pop();
  },
  pop: function pop() {
    var alert = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.alert);
    this.alert = {};
    return alert;
  },
  compile: function compile(data) {
    return {
      'Already exists': 'Sorte ' + data['name'] + ' existiert bereits'
    };
  }
};

/* harmony default export */ __webpack_exports__["a"] = (flash);

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(100)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(122),
  /* scopeId */
  "data-v-f497a714",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_script_loader_jquery__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_script_loader_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_script_loader_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_script_loader_bootstrap_js_dist_util__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_script_loader_bootstrap_js_dist_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_script_loader_bootstrap_js_dist_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_script_loader_bootstrap_js_dist_alert__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_script_loader_bootstrap_js_dist_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_script_loader_bootstrap_js_dist_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_creams_index__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_creams_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pages_creams_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_creams_new__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_creams_new___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_pages_creams_new__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_creams_edit__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_creams_edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_pages_creams_edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_selections_edit__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_selections_edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_pages_selections_edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_login__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_pages_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_auth__ = __webpack_require__(6);













__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  routes: [{
    path: '/creams',
    component: __WEBPACK_IMPORTED_MODULE_5__components_pages_creams_index___default.a,
    meta: {
      authorized: 'creams-edit'
    }
  }, {
    path: '/creams/new',
    component: __WEBPACK_IMPORTED_MODULE_6__components_pages_creams_new___default.a,
    meta: {
      authorized: 'creams-edit'
    }
  }, {
    path: '/creams/edit/:id',
    component: __WEBPACK_IMPORTED_MODULE_7__components_pages_creams_edit___default.a,
    meta: {
      authorized: 'creams-edit'
    }
  }, {
    name: 'selectionsEdit',
    path: '/selections/:id',
    component: __WEBPACK_IMPORTED_MODULE_8__components_pages_selections_edit___default.a,
    props: true
  }, {
    path: '/access-denied',
    component: {
      template: '<p>Zugang verweigert.</p>'
    }
  }, {
    path: '/login',
    component: __WEBPACK_IMPORTED_MODULE_9__components_pages_login___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      if (__WEBPACK_IMPORTED_MODULE_10__services_auth__["b" /* auth */].current) return next('/');
      next();
    }
  }, {
    path: '/',
    redirect: function redirect() {
      if (__WEBPACK_IMPORTED_MODULE_10__services_auth__["b" /* auth */].isAuthorized('creams-edit')) {
        return '/creams';
      } else if (__WEBPACK_IMPORTED_MODULE_10__services_auth__["b" /* auth */].current.permissions) {
        try {
          var id = __WEBPACK_IMPORTED_MODULE_10__services_auth__["b" /* auth */].current.permissions[0]['selections-edit'][0];
          return '/selections/' + id;
        } catch (err) {
          return '/access-denied';
        }
      } else {
        return '/login';
      }
    }
  }]
});

router.beforeEach(function login(to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_10__services_auth__["b" /* auth */].current) {
    return next();
  }

  var _userStorage$get = __WEBPACK_IMPORTED_MODULE_10__services_auth__["c" /* userStorage */].get(),
      username = _userStorage$get.username,
      password = _userStorage$get.password;

  __WEBPACK_IMPORTED_MODULE_10__services_auth__["b" /* auth */].login(username, password).then(function () {
    next();
  }).catch(function (reason) {
    if (reason instanceof Error) throw reason;
    if (to.path === '/login') return next();
    next('/login');
  });
});

router.beforeEach(function authorize(to, from, next) {
  if (to.meta.authorized) {
    if (__WEBPACK_IMPORTED_MODULE_10__services_auth__["b" /* auth */].isAuthorized(to.meta.authorized, to.params.id)) {
      return next();
    } else {
      return next(false);
    }
  }
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(93)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(115),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 43 */,
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(41);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<app/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__app___default.a }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_navbar__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layout_navbar__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: { Navbar: __WEBPACK_IMPORTED_MODULE_0__components_layout_navbar___default.a }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_auth__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      user: {}
    };
  },


  computed: {
    loggedIn: function loggedIn() {
      return this.user;
    }
  },

  watch: {
    $route: function $route() {
      this.user = __WEBPACK_IMPORTED_MODULE_0__services_auth__["a" /* default */].current;
    }
  },

  methods: {
    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_0__services_auth__["a" /* default */].logout();
      this.$router.replace('/login');
    },
    isAuthorized: function isAuthorized(action, restriction) {
      return __WEBPACK_IMPORTED_MODULE_0__services_auth__["a" /* default */].isAuthorized(action, restriction);
    }
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      image: {}
    };
  },


  props: {
    cream: {
      type: Object,
      default: function _default() {
        return {
          name: '',
          imagePath: '',
          vegan: false,
          lactosefree: false,
          glutenfree: true
        };
      }
    },
    alert: {
      type: Object
    }
  },

  watch: {
    'cream.vegan': function creamVegan(vegan) {
      this.cream.lactosefree = vegan;
    }
  },

  computed: {
    isExisting: function isExisting() {
      return !!this.cream.id;
    },
    cacheBust: function cacheBust() {
      return Math.floor(Math.random() * 1000000);
    }
  },

  methods: {
    onChangeFile: function onChangeFile(event) {
      var file = event.target.files[0];
      if (file) {
        this.image = file;
      }
    },
    onSubmit: function onSubmit() {
      this.$emit('submit', {
        cream: this.cream,
        form: form(this.cream, this.image)
      });
    },
    onDelete: function onDelete() {
      this.$emit('delete', this.cream);
    }
  }
});

function form(cream, image) {
  var form = new FormData();
  form.append('cream', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(cream));
  form.append('image', image);
  return form;
}

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_flash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__form__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { creamsForm: __WEBPACK_IMPORTED_MODULE_1__form___default.a },

  data: function data() {
    return {
      cream: {},
      alert: {}
    };
  },
  created: function created() {
    var _this = this;

    var id = this.$route.params.id;
    this.$http.get('/api/creams/' + id).then(function (res) {
      _this.cream = res.body.cream;
    }).catch(function (reason) {
      return console.log(reason);
    });
  },


  methods: {
    onSubmit: function onSubmit(_ref) {
      var _this2 = this;

      var cream = _ref.cream,
          form = _ref.form;

      if (!cream.id) throw new Error('Missing id');
      this.$http.post('/api/creams/' + cream.id, form).then(function () {
        __WEBPACK_IMPORTED_MODULE_0__services_flash__["a" /* default */].set({
          type: 'info',
          message: 'Sorte ' + cream.name + ' aktualisiert'
        });
        _this2.$router.push('/creams');
      }).catch(function (reason) {
        if (!reason.body.errors) return console.log(reason);
        _this2.alert = __WEBPACK_IMPORTED_MODULE_0__services_flash__["a" /* default */].now({
          type: 'danger',
          code: reason.body.errors[0],
          data: {
            name: cream.name
          }
        });
      });
    },
    onDelete: function onDelete(cream) {
      var _this3 = this;

      if (!cream.id) throw new Error('Missing id');
      this.$http.delete('/api/creams/' + cream.id, { cream: cream }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0__services_flash__["a" /* default */].set({
          type: 'warning',
          message: 'Sorte ' + cream.name + ' gel\xF6scht'
        });
        _this3.$router.push('/creams');
      }).catch(function (reason) {
        return console.log(reason);
      });
    }
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_flash__ = __webpack_require__(10);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'creams',
  data: function data() {
    return {
      creams: [],
      alert: {}
    };
  },
  created: function created() {
    var _this = this;

    this.alert = __WEBPACK_IMPORTED_MODULE_0__services_flash__["a" /* default */].pop();
    this.$http.get('/api/creams').then(function (res) {
      _this.creams = res.body.creams;
    }).catch(function (reason) {
      return console.log(reason);
    });
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_flash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__form__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { creamsForm: __WEBPACK_IMPORTED_MODULE_1__form___default.a },

  data: function data() {
    return {
      alert: {}
    };
  },


  methods: {
    onSubmit: function onSubmit(_ref) {
      var _this = this;

      var cream = _ref.cream,
          form = _ref.form;

      this.$http.post('/api/creams', form).then(function () {
        __WEBPACK_IMPORTED_MODULE_0__services_flash__["a" /* default */].set({
          type: 'success',
          message: 'Sorte ' + cream.name + ' hinzugef\xFCgt'
        });
        _this.$router.push('/creams');
      }).catch(function (reason) {
        if (!reason.body.errors) return console.log(reason);
        _this.alert = __WEBPACK_IMPORTED_MODULE_0__services_flash__["a" /* default */].now({
          type: 'danger',
          code: reason.body.errors[0],
          data: {
            name: cream.name
          }
        });
      });
    }
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_auth__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      user: {
        username: '',
        password: ''
      },
      error: {
        message: ''
      }
    };
  },


  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      var _user = this.user,
          username = _user.username,
          password = _user.password;

      __WEBPACK_IMPORTED_MODULE_0__services_auth__["a" /* default */].login(username, password).then(function () {
        _this.error = {};
        _this.$router.replace('/');
      }).catch(function (reason) {
        if (reason instanceof Error) throw reason;
        _this.user.username = '';
        _this.user.password = '';
        _this.error.message = 'Login fehlgeschlagen';
        _this.$refs.username.focus();
      });
    }
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_auth__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['all', 'selected', 'ids'],

  methods: {
    selectedOrUnassignedCreams: function selectedOrUnassignedCreams(selectedCream) {
      var _this = this;

      var result = this.all.filter(function (cream) {
        var isAssigned = _this.ids.includes(cream.id);
        var isSelected = cream.id === selectedCream.id;
        return !isAssigned || isSelected;
      });
      return result;
    },
    isAuthorized: function isAuthorized(action, restriction) {
      return __WEBPACK_IMPORTED_MODULE_0__services_auth__["a" /* default */].isAuthorized(action, restriction);
    }
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_auth__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_flash__ = __webpack_require__(10);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { selectionsIndex: __WEBPACK_IMPORTED_MODULE_1__index___default.a },

  props: ['id'],

  data: function data() {
    return {
      creams: [],
      selectedCreams: {
        left: [],
        right: []
      },
      alert: {},
      touched: false
    };
  },


  computed: {
    location: function location() {
      return { 1: 'Mannheim', 2: 'Limburgerhof' }[this.id];
    },
    selectedIds: function selectedIds() {
      var leftIds = this.selectedCreams.left.map(function (cream) {
        return cream.id;
      });
      var rightIds = this.selectedCreams.right.map(function (cream) {
        return cream.id;
      });
      return leftIds.concat(rightIds);
    }
  },

  watch: {
    $route: function $route() {
      this.alert = {};
      this.fetch();
    }
  },

  created: function created() {
    var _this = this;

    this.$http.get('/api/creams').then(function (res) {
      _this.creams = res.body.creams;
      _this.fetch();
    }).catch(function (reason) {
      return console.log(reason);
    });
  },


  methods: {
    onChange: function onChange() {
      this.touched = true;
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$http.post('/api/selections/' + this.id, { creamIds: this.selectedIds }).then(function () {
        _this2.touched = false;
        _this2.alert = __WEBPACK_IMPORTED_MODULE_3__services_flash__["a" /* default */].now({
          type: 'info',
          message: 'Auswahl am Standort ' + _this2.location + ' aktualisiert'
        });
      }).catch(function (reason) {
        return console.log(reason);
      });
    },
    fetch: function fetch() {
      var _this3 = this;

      this.selectedCreams.left = new Array(8).fill('');
      this.selectedCreams.right = new Array(8).fill('');
      this.$http.get('/api/selections/' + this.id).then(function (res) {
        var selections = res.body.creams;
        selections.forEach(function (selection, index) {
          var cream = findCreamById(_this3.creams, selection['cream_id']);
          var position = selection.position;

          if (position < 8) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(_this3.selectedCreams.left, position, cream);
          } else {
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(_this3.selectedCreams.right, position - 8, cream);
          }
        });
      });
    },
    isAuthorized: function isAuthorized(action, restriction) {
      return __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].isAuthorized(action, restriction);
    },
    previewHref: function previewHref(name) {
      return '/resources/rendered/' + this.id + '/' + name;
    }
  }
});

function findCreamById(creams, id) {
  return creams.find(function (cream) {
    return cream.id === id;
  });
}

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(94)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(116),
  /* scopeId */
  "data-v-3da44abf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(99)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(121),
  /* scopeId */
  "data-v-9588aaf2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(92)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(114),
  /* scopeId */
  "data-v-33f16025",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(97)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(119),
  /* scopeId */
  "data-v-57e8fcb3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(96)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(118),
  /* scopeId */
  "data-v-4c3d5d88",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(98)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(120),
  /* scopeId */
  "data-v-65507d1a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(95)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(117),
  /* scopeId */
  "data-v-3dd6ab91",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "creams"
  }, [_c('div', {
    staticClass: "creams-actions row justify-content-end"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/creams/new"
    }
  }, [_vm._v("\n      Sorte hinzufügen\n    ")])], 1), _vm._v(" "), (_vm.alert.message) ? _c('div', {
    staticClass: "creams-alert"
  }, [_c('div', {
    staticClass: "alert alert-dismissable fade show",
    class: 'alert-' + _vm.alert.type
  }, [_vm._m(0), _vm._v("\n      " + _vm._s(_vm.alert.message) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "creams-index table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.creams), function(cream) {
    return _c('tr', [_c('td', {
      staticClass: "name"
    }, [_c('router-link', {
      attrs: {
        "to": '/creams/edit/' + cream.id
      }
    }, [_vm._v("\n            " + _vm._s(cream.name) + "\n          ")])], 1)])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert"
    }
  }, [_c('span', [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Sorte")]), _vm._v(" "), _c('th')])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('navbar'), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "main"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-toggleable-sm navbar-light bg-faded"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("\n    zeitgeist "), _c('span', [_vm._v("creams")])]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbarSupportedContent"
    }
  }, [(_vm.loggedIn) ? _c('ul', {
    staticClass: "navbar-nav mr-auto"
  }, [(_vm.isAuthorized('creams-edit')) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/creams"
    }
  }, [_vm._v("Sorten")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/selections/1"
    }
  }, [_vm._v("\n          Mannheim\n        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/selections/2"
    }
  }, [_vm._v("\n          Limburgerhof\n        ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.user.username) ? _c('ul', {
    staticClass: "navbar-nav"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_vm._v("\n          Logout (" + _vm._s(_vm.user.username) + ")\n        ")])])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler navbar-toggler-right",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarSupportedContent"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
}]}

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selections"
  }, [(_vm.alert.message) ? _c('div', {
    staticClass: "selections-alert"
  }, [_c('div', {
    staticClass: "alert alert-dismissable fade show",
    class: 'alert-' + _vm.alert.type
  }, [_vm._m(0), _vm._v("\n      " + _vm._s(_vm.alert.message) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "selections-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      },
      "change": _vm.onChange
    }
  }, [_c('div', {
    staticClass: "selections-side left row"
  }, [_c('h4', [_vm._v("\n        Links\n        "), _c('small', [_c('a', {
    attrs: {
      "href": _vm.previewHref('left.jpg'),
      "target": "_blank"
    }
  }, [_vm._v("Vorschau")])])]), _vm._v(" "), _c('selections-index', {
    attrs: {
      "all": _vm.creams,
      "ids": _vm.selectedIds,
      "selected": _vm.selectedCreams.left
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "selections-side right row"
  }, [_c('h4', [_vm._v("\n        Rechts\n        "), _c('small', [_c('a', {
    attrs: {
      "href": _vm.previewHref('right.jpg'),
      "target": "_blank"
    }
  }, [_vm._v("Vorschau")])])]), _vm._v(" "), _c('selections-index', {
    attrs: {
      "all": _vm.creams,
      "ids": _vm.selectedIds,
      "selected": _vm.selectedCreams.right
    }
  })], 1), _vm._v(" "), (_vm.isAuthorized('selections-edit', _vm.id)) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-lg-2 col-3"
  }, [_c('button', {
    staticClass: "btn btn-primary save",
    attrs: {
      "disabled": !_vm.touched
    }
  }, [_vm._v("\n          Aktualisieren\n        ")])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert"
    }
  }, [_c('span', [_vm._v("×")])])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [(_vm.error.message) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_c('strong', [_vm._v(_vm._s(_vm.error.message))]), _c('br'), _vm._v("\n          Bitte die Zugangsdaten prüfen.\n        ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "login-username"
    }
  }, [_vm._v("Benutzer")]), _vm._v(" "), _c('div', {
    staticClass: "col offset-sm-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.username),
      expression: "user.username"
    }],
    ref: "username",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "login-username",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.user.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.username = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "login-password"
    }
  }, [_vm._v("Passwort")]), _vm._v(" "), _c('div', {
    staticClass: "col offset-sm-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "login-password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col offset-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Login")])])])
}]}

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "creams-new"
  }, [_c('creams-form', {
    attrs: {
      "alert": _vm.alert
    },
    on: {
      "submit": _vm.onSubmit
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selections-index row"
  }, _vm._l((_vm.selected), function(item, index) {
    return _c('div', {
      staticClass: "selection col col-md-3 col-6"
    }, [_c('div', {
      staticClass: "selections-image"
    }, [(item.imagePath) ? _c('img', {
      attrs: {
        "src": ("/" + (item.imagePath))
      }
    }) : _vm._e()]), _vm._v(" "), (_vm.isAuthorized('selections-edit', _vm.$route.params.id)) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected[index]),
        expression: "selected[index]"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          var $$exp = _vm.selected,
            $$idx = index;
          if (!Array.isArray($$exp)) {
            _vm.selected[index] = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
          } else {
            $$exp.splice($$idx, 1, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Sorte wählen")]), _vm._v(" "), _vm._l((_vm.selectedOrUnassignedCreams(_vm.selected[index])), function(cream) {
      return _c('option', {
        domProps: {
          "value": cream
        }
      }, [_vm._v("\n        " + _vm._s(cream.name) + "\n      ")])
    })], 2) : _vm._e()])
  }))
},staticRenderFns: []}

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('creams-form', {
    attrs: {
      "cream": _vm.cream,
      "alert": _vm.alert
    },
    on: {
      "submit": _vm.onSubmit,
      "delete": _vm.onDelete
    }
  })
},staticRenderFns: []}

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [(_vm.alert.message) ? _c('div', [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.alert.type
  }, [_vm._v("\n      " + _vm._s(_vm.alert.message) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "cream-name"
    }
  }, [_vm._v("Sorte")]), _vm._v(" "), _c('div', {
    staticClass: "col offset-sm-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cream.name),
      expression: "cream.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": "",
      "id": "cream-name"
    },
    domProps: {
      "value": (_vm.cream.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cream.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "form-check col offset-sm-3"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cream.vegan),
      expression: "cream.vegan"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.cream.vegan) ? _vm._i(_vm.cream.vegan, null) > -1 : (_vm.cream.vegan)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.cream.vegan,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.cream.vegan = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.cream.vegan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.cream.vegan = $$c
        }
      }
    }
  }), _vm._v("\n        Vegan\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "form-check col offset-sm-3"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cream.lactosefree),
      expression: "cream.lactosefree"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.cream.lactosefree) ? _vm._i(_vm.cream.lactosefree, null) > -1 : (_vm.cream.lactosefree)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.cream.lactosefree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.cream.lactosefree = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.cream.lactosefree = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.cream.lactosefree = $$c
        }
      }
    }
  }), _vm._v("\n        Laktosefrei\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "form-check col offset-sm-3"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cream.glutenfree),
      expression: "cream.glutenfree"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.cream.glutenfree) ? _vm._i(_vm.cream.glutenfree, null) > -1 : (_vm.cream.glutenfree)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.cream.glutenfree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.cream.glutenfree = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.cream.glutenfree = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.cream.glutenfree = $$c
        }
      }
    }
  }), _vm._v("\n        Glutenfrei\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "cream-image"
    }
  }, [_vm._v("Bild")]), _vm._v(" "), _c('div', {
    staticClass: "col offset-sm-1"
  }, [(_vm.cream.imagePath) ? _c('div', {
    staticClass: "cream-image"
  }, [_c('img', {
    attrs: {
      "src": ("/" + (_vm.cream.imagePath) + "?" + _vm.cacheBust)
    }
  })]) : _vm._e(), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "required": !_vm.isExisting,
      "id": "cream-image"
    },
    on: {
      "change": _vm.onChangeFile
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col offset-3"
  }, [_c('button', {
    staticClass: "btn btn-primary save",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Speichern")]), _vm._v(" "), _c('router-link', {
    staticClass: "back",
    attrs: {
      "to": "/creams"
    }
  }, [_vm._v("Zurück")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col offset-3"
  }, [(_vm.isExisting) ? _c('button', {
    staticClass: "btn btn-secondary delete",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onDelete($event)
      }
    }
  }, [_vm._v("\n        Löschen\n      ")]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[44]);


// WEBPACK FOOTER //
// static/js/app.207a1b78011ea0827c99.js